import { TenantTicket } from '../../../apis/types'
import TicketItem from './TicketItem'

interface TicketsPanelProps {
  tickets: TenantTicket[]
  ticketRequestPhase: { kind: 'idle' } | { kind: 'in-progress' } | { kind: 'failed' }
  totalTicketCount: number
}

const TicketsPanel: React.FC<TicketsPanelProps> = ({
  tickets,
  ticketRequestPhase,
  totalTicketCount,
}) => {
  if (ticketRequestPhase.kind === 'in-progress') {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-500"></div>
      </div>
    )
  }

  if (ticketRequestPhase.kind === 'failed') {
    return (
      <div className="text-center py-8 text-red-500 dark:text-red-400">
        Failed to load tickets. Please try again.
      </div>
    )
  }

  if (tickets.length === 0) {
    return (
      <div className="text-center py-8 text-slate-500 dark:text-slate-400">
        No support tickets linked to this tenant.
      </div>
    )
  }

  return (
    <div className="space-y-3">
      <div className="text-xs text-slate-500 dark:text-slate-400 mb-2">
        {totalTicketCount} ticket{totalTicketCount !== 1 ? 's' : ''} linked
      </div>
      {tickets.map((ticket) => (
        <TicketItem key={ticket.cuid} ticket={ticket} />
      ))}
    </div>
  )
}

export default TicketsPanel
